import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Particle } from "../../components";
import Resumecontent from "./ResumeContent";
import pdf from "../../Assets/harshit.pdf";
import { AiOutlineDownload } from "react-icons/ai";

const Resume = () => {

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="SOFTWARE ENGINEER"
              college="Singsys Software Services Pvt. Ltd."
              date="September 2020 - present"
              content={[
                "Worked closely with software development and testing team members to design and develop robust solutions to meet client requirements for functionality, scalability and performance.",
                "Designed and developed admin panel for various mobile applications.",
                "Developed REST-APIs for different projects.",
                "Developed web services for mobile applications."
              ]}
            />
            {/* <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Web Developer"
              content={[
                "Worked on creating the frontend-end of the website using Bootstrap, Javascript.",
              ]}
            />
            <Resumecontent
              title="Web Developer"
              content={[
                "Operated on developing the frontend end of the website using Bootstrap, Javascript and backend APIs using Node.js",
              ]}
            /> */}
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="MCA"
              college="Babasaheb Bhimrao Ambedkar University,Lucknow"
              date="2017 - 2020"
              content={[`CGPA: 8.25`]}
            />
            <Resumecontent
              title="BCA"
              college="Dr. Ram Manohar Lohia Awadh University,Ayodhya"
              date="2013 - 2016"
              content={[`Precentage: 71.33%`]}
            />
            <Resumecontent
              title="12TH ( UP BOARD )"
              college="Sri Sai Inter College,Lakhperabagh (Barabanki)"
              date="2010 - 2012"
              content={["Precentage: 79.60%"]}
            />
            <Resumecontent
              title="10TH ( UP BOARD )"
              college="Yug Nirman Inter College,Harakh (Barabanki)"
              date="2010"
              content={["Precentage: 69.83%"]}
            />
            {/* <h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                `Current rank in Spoj ${spojRank}`,
                `Current rank in HackerRank  ${hackerrank}`,
                "Top Performer in Code-Break 1.0",
                "Participant in Hack-A-Bit 2019",
              ]}
            /> */}
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />&nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
